import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../utils/axiosConfig';
import '../styles/AllVendors.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faStore, faArrowRight, faLocationDot } from '@fortawesome/free-solid-svg-icons';

function AllVendorsPage() {
  const [vendors, setVendors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/api/vendors/all');
      setVendors(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching vendors:', error);
      setIsLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredVendors = vendors.filter(vendor => 
    vendor.business_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="vendor-directory">

        <div className="ml-vendor-directory-header">
        <div className="ml-vendor-directory-container">
          <div className="ml-vendor-directory-header-content">
            <h1 className="ml-vendor-directory-title">Discover Local Businesses</h1>
            <p className="ml-vendor-directory-subtitle">
              Explore our collection of local businesses offering loyalty programs, special offers, and more.
            </p>
            <div className="ml-vendor-directory-search-wrapper">
              <div className="ml-vendor-directory-search">
                <input 
                  type="text" 
                  placeholder="Search businesses..." 
                  value={searchTerm}
                  onChange={handleSearch}
                  className="ml-vendor-directory-search-input"
                />
                <button className="ml-vendor-directory-search-button" onClick={() => handleSearch({ target: { value: searchTerm }})}>
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="vendor-directory__content">
        <div className="vendor-directory__container">
          {isLoading ? (
            <div className="vendor-directory__loading">
              <div className="vendor-directory__loading-spinner"></div>
              <p>Loading businesses...</p>
            </div>
          ) : filteredVendors.length > 0 ? (
            <div className="vendor-directory__grid">
              {filteredVendors.map(vendor => (
                <div key={vendor.id} className="vendor-directory__card">
                  <div className="vendor-directory__logo">
                    {vendor.logo_url ? (
                      <img 
                        src={vendor.logo_url} 
                        alt={`${vendor.business_name} logo`} 
                        className="vendor-directory__logo-img"
                      />
                    ) : (
                      <div className="vendor-directory__logo-placeholder">
                        <FontAwesomeIcon icon={faStore} />
                      </div>
                    )}
                  </div>
                  <div className="vendor-directory__info">
                    <h2 className="vendor-directory__business-name">{vendor.business_name}</h2>
                    <p className="vendor-directory__description">
                      {vendor.address || "Local business offering loyalty rewards"}
                    </p>
                    {vendor.address && (
                      <p className="vendor-directory__location">
                        <FontAwesomeIcon icon={faLocationDot} />
                        <span>{vendor.address}</span>
                      </p>
                    )}
                    <Link to={`/vendor/${vendor.sub_url}`} className="vendor-directory__link">
                      View Rewards <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="vendor-directory__no-results">
              <p>No businesses found matching "{searchTerm}"</p>
              <button onClick={() => setSearchTerm('')} className="vendor-directory__reset-btn">
                Clear Search
              </button>
            </div>
          )}
        </div>
      </div>
      
      <div className="vendor-directory__cta">
        <div className="vendor-directory__container">
          <h2>Own a Business?</h2>
          <p>Join our network and offer your customers loyalty rewards and special offers.</p>
          <button 
            className="vendor-directory__cta-btn" 
            onClick={() => navigate('/vendor/register')}
          >
            Register Your Business
          </button>
        </div>
      </div>
    </div>
  );
}

export default AllVendorsPage;